import axios from 'axios'
import config from '../config/app'

const roleAPI = {
  getAll () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/role/get-all').then((response) => {
        resolve(response.data.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getByGroups () {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/role/get-by-groups').then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}

export default roleAPI



// WEBPACK FOOTER //
// ./src/api/role.js